import { render, staticRenderFns } from "./mockery.vue?vue&type=template&id=4745b5ac&scoped=true&"
import script from "./mockery.vue?vue&type=script&lang=js&"
export * from "./mockery.vue?vue&type=script&lang=js&"
import style0 from "./mockery.vue?vue&type=style&index=0&id=4745b5ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4745b5ac",
  null
  
)

export default component.exports